import React from 'react'
import { connect } from 'react-redux'
import { closeExportDialogue } from '../../actioncreators/actioncreators'
import styled from 'styled-components'

const { Component } = React

const Modal = styled.div`
  display: none;
  position: fixed;
  z-index: 10001;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: none;
  background-color: rgb(0,0,0);
  background-color: rgba(0,0,0,0.4);
`

const Dialogue = styled.div`
  background-color: #fefefe;
  margin: 10% auto;
  padding: 20px;
  border: 1px solid #888;
  width: 60%;
  border-radius: 5px;
`

let copy = () => {
  console.log('copying')
  let textArea = document.querySelector('#textToCopy')
  textArea.select()

  try {
    let successful = document.execCommand('copy')
    if (successful) {
      setTemporaryFeedback('copied...')
    } else {
      setTemporaryFeedback('unable to copy...')
    }
  } catch (err) {
    setTemporaryFeedback('unable to copy...')
  }
}

let setTemporaryFeedback = (message) => {
  document.getElementById('copyFeedback').innerText = message
  setTimeout(clearCopyFeedback, 2000)
}

let clearCopyFeedback = () => {
  document.getElementById('copyFeedback').innerHTML = '&nbsp;'
}

class ExportDialogue extends Component {
  render () {
    let exportText = '# Rules\n\n'

    this.props.rules.forEach((ruleRow) => {
      ruleRow.forEach((rule) => {
        let examplesText = ''
        rule.examples.forEach((example, exampleIndex) => {
          examplesText += example.text.length > 0 ? `- ${example.text}\n` : String.fromCharCode(160)
        })

        exportText += rule.text.length > 0 ? `## ${rule.text}\n` : String.fromCharCode(160)
        exportText += examplesText
        exportText += '\n'
      })
    })

    exportText += '# Questions\n\n'
    this.props.questions.forEach((question) => {
      exportText += question.text.length > 0 ? `## ${question.text}\n\n` : String.fromCharCode(160)
    })

    return (
      <Modal style={{ display: this.props.displayExportDialogue ? 'block' : 'none' }} onClick={this.props.close}>
        <Dialogue onClick={this.props.stopPropagation}>
          <h3>Export Example Map</h3>
          <textarea id='textToCopy' value={exportText} style={{ width: '100%' }} rows={20} />
          <div className='text-right' style={{ marginTop: 20 }}>
            <span id='copyFeedback' style={{ marginRight: 20, fontWeight: 'bold' }}>&nbsp;</span>
            <button type='button' className='btn btn-default' onClick={this.props.close}>Close</button>&nbsp;
            <button type='button' className='btn btn-primary' onClick={copy}>Export to clipboard</button>
          </div>
        </Dialogue>
      </Modal>
    )
  }
}

const mapStateToProps = function (store, ownProps) {
  let numberOfRules = 0
  store.rules.forEach(row => {
    numberOfRules += row.length
  })
  return {
    rules: store.rules,
    questions: store.questions,
    rulesPresent: numberOfRules > 0,
    displayExportDialogue: store.general.displayExportDialogue
  }
}

const mapDispatchToProps = function (dispatch, ownProps) {
  return {
    close: () => { dispatch(closeExportDialogue()) },
    stopPropagation: (e) => { e.stopPropagation() }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ExportDialogue)
